import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Shield, Lock, ArrowRight } from "lucide-react";

interface PaywallInterstitialProps {
  onContinue: () => void;
  isLoading: boolean;
}

const PaywallInterstitial = ({ onContinue, isLoading }: PaywallInterstitialProps) => {
  return (
    <div className="max-w-2xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500">
      <Card className="p-10 shadow-2xl border-2 border-primary/20 bg-gradient-to-br from-background to-primary/5">
        <div className="text-center space-y-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mx-auto">
            <Lock className="w-8 h-8 text-primary" />
          </div>

          <div className="space-y-3">
            <h2 className="text-3xl font-bold">Your profile is taking shape...</h2>
            <p className="text-lg text-muted-foreground">
              Unlock your complete strategy for $5 — a one-time payment. No subscription.
            </p>
          </div>

          <Button
            size="lg"
            onClick={onContinue}
            disabled={isLoading}
            className="w-full text-xl py-7 bg-gradient-to-r from-primary to-accent hover:opacity-90 transition-opacity shadow-lg disabled:opacity-50"
          >
            {isLoading ? "Starting checkout..." : "Continue & Pay $5"}
            {!isLoading && <ArrowRight className="w-5 h-5 ml-2" />}
          </Button>

          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Shield className="w-4 h-4 text-primary" />
            <span>Stripe secure checkout. Instant delivery to your email.</span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PaywallInterstitial;
